module.exports = __webpack_public_path__ + "img/send.ab8875e6.svg";